import React from "react";
import { useKeycloak } from "../../hooks/useKeycloak";
import styles from "./toolbar.module.scss";
import { MessageHelper } from "../../helpers/MessageHelper";
import LightweightButton from "../button/LightweightButton";
const { Color, Icon } = require("@vhv/ui-kit/dist/collection/utils/utils");
export const AppToolbar = () => {
    const { keycloak } = useKeycloak();
    const queryParams = new URLSearchParams(window.location.search);
    const redirectToPortalUrl = queryParams.get("redirect_uri") || localStorage.getItem("redirect_uri");
    if (redirectToPortalUrl) {
        localStorage.setItem("redirect_uri", redirectToPortalUrl);
    }
    const navigateBackToPortal = () => {
        window.location.href = redirectToPortalUrl ? redirectToPortalUrl : window.location.href;
    };
    return React.createElement("div", { className: styles.toolbar },
        React.createElement("div", { className: styles.vertical },
            !!redirectToPortalUrl && (React.createElement(LightweightButton, { className: styles.appToolbarItem, color: Color.SECONDARY, icon: Icon.DASHBOARD, onClick: () => navigateBackToPortal() },
                React.createElement(MessageHelper, { msgKey: "backToPortal" }))),
            React.createElement(LightweightButton, { className: styles.appToolbarItem, color: Color.SECONDARY, icon: Icon.LOGOUT, onClick: () => keycloak.logout() },
                React.createElement(MessageHelper, { msgKey: "doSignOut" }))));
};
